import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './NoOffers.scss';
import '../../resources/main.scss'
import Header from "../../components/Header/Header";
import MobileMenu from "../../components/Menu/MobileMenu";
import { bidingService } from "../../services/BidingService";


const NoOffers = () => {
    const navigate = useNavigate();

    useEffect(() => {
        bidingService.getActiveBidding()
            .then((response) => {
                const payload = response?.data;
                const hasActiveBidding = payload?.active === true;
                const biddingIdentifier = payload?.bidding?.token || payload?.bidding?.id;

                if (hasActiveBidding && biddingIdentifier) {
                    navigate(`/produse-ofertare/${biddingIdentifier}`, { replace: true });
                }
            })
            .catch(() => {
                // If no active bidding exists or request fails, remain on no-offers page.
            });
    }, [navigate]);


    return (
        <div className='standard offer'>
            <MobileMenu/>
            <Header />
            <div className='offer__wrapper'>
                <div className='offer__left-part'>
                    <h2 className='offer__info'>Momentan nu avem ofertări deschise. Toate solicitările de ofertă sunt anunțate prin e-mail sau WhatsApp.</h2>

                </div>

                <div className='offer__right-part standard__only-desktop'>
                <img src="/images/no-offers-icon.png" alt='no-offers' className='offer__img'/>

                </div>
            </div>

        </div>
    );
};

export default NoOffers;
